module.exports = __webpack_public_path__ + "static/img/gate.7e0edaa7.png";